// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2z1gm","tooltipImg":"Tooltip_tooltipImg__-x2Zi","close":"Tooltip_close__2EDbz"};